import { render, staticRenderFns } from "./ListTemplateFields.vue?vue&type=template&id=a519f1b2&scoped=true&"
import script from "./ListTemplateFields.vue?vue&type=script&lang=js&"
export * from "./ListTemplateFields.vue?vue&type=script&lang=js&"
import style0 from "./ListTemplateFields.vue?vue&type=style&index=0&id=a519f1b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a519f1b2",
  null
  
)

export default component.exports